import * as React from "react";
import { GanttPointOptionsObject } from "highcharts";
import { GanttOperation, GanttResource } from "../../common/communication.base";
import { ColorProps } from "../K2Gantt";

export const getOperations = (items: any[][]) => {
  if (items == undefined) return [];

  const operations: GanttOperation[] = items.map(
    (item): GanttOperation => {
      return {
        operationId: item[0],
        parentId: item[1],
        name: item[2],
        serieName: item[3],
        datetimeFrom: item[4],
        datetimeTo: item[5],
        completed: item[6],
        isMilestone: item[7],
        isStage: item[8],
        resourceId: item[9],
        resourceOrder: item[10],
        isExpanded: item[11],
        isInCollision: item[12],
        dependencyIds: item[13],
        dependencyTypes: item[14],
        customColor: item[15],
        workTime: item[16],
        workTimeUnit: item[17],
        htmlTooltip: item[18],
        description: item[19],
      };
    }
  );

  return operations;
};

export const getResources = (items: any[][]) => {
  if (items == undefined) return [];

  const resources: GanttResource[] = items.map(
    (item): GanttResource => {
      return {
        resourceID: item[0],
        name: item[1],
        order: item[2],
        abbr: item[3],
        hasCollision: item[4],
      };
    }
  );

  return resources;
};

interface GanttPoint extends Highcharts.GanttPointOptionsObject {
  borderColor?: string;
  borderWidth?: number;
  custom?: {
    workTime: number;
    workTimeUnit: string;
    htmlTooltip: string;
  };
}

export const getDataitems = (
  items: GanttOperation[],
  byResources: boolean,
  arrayOfCategories: string[],
  byOperations: boolean,
  ownColors: boolean
): Highcharts.GanttPointOptionsObject[] => {
  const offset = 365 * 70 + 19;
  const day = 1000 * 60 * 60 * 24;

  let dataitems: Highcharts.GanttPointOptionsObject[] = items.map(
    (item, itemindex): GanttPoint => {
      let itemdependencies: Array<Highcharts.XrangePointConnectorsOptionsObject>;

      let itemdependency_ids_string: string;
      itemdependency_ids_string = item.dependencyIds;
      let itemdependency_ids: string[] = itemdependency_ids_string.split(";");

      let itemdependency_types_string: string;
      itemdependency_types_string = item.dependencyTypes;
      let itemdependency_types: string[] = itemdependency_types_string.split(";");

      if (itemdependency_ids[0].trim().length > 0) {
        itemdependencies = [];

        for (let i = 0; i < itemdependency_ids.length; i++) {
          //if (itemdependency_ids[i].trim() == "") {
          //  continue;
          //}

          let dependentitem: Highcharts.XrangePointConnectorsOptionsObject = {};
          dependentitem.to = itemdependency_ids[i];
          // dependentitem.type = "fastAvoid"; //nejde

          switch (itemdependency_types[i]) {
            case "FS": //Task B starts after task A is finished
              //default
              break;

            case "FF": //Task B must end together with task A
              dependentitem.startMarker = {
                align: "right", // Where to start the line (horizontally)
                enabled: true, // Add the marker symbol
              };
              dependentitem.endMarker = {
                align: "right", // Where to end the line (horizontally)
              };
              break;

            case "SS": //Tasks A and B start together
              (dependentitem.startMarker = {
                align: "left", // Where to start the line (horizontally)
                enabled: true, // Add the marker symbol
              }),
                (dependentitem.endMarker = {
                  align: "left", // Where to end the line (horizontally)
                });
              break;

            case "SF": //Task B must start before task A finishes
              (dependentitem.startMarker = {
                align: "right", // Where to start the line (horizontally)
                enabled: true, // Add the marker symbol
              }),
                (dependentitem.endMarker = {
                  align: "left", // Where to end the line (horizontally)
                });
              break;

            default: //0
          }

          itemdependencies.push(dependentitem);
        }
      }

      const data = {
        collapsed: item.isExpanded ? false : true,
        id: item.operationId.toString(),
        name: item.name,
        description: byResources ? item.name : item.description, //arrayOfCategories[item.resourceOrder],
        start: Math.round((item.datetimeFrom - offset) * day),
        end: Math.round((item.datetimeTo - offset) * day),
        completed: Math.round(item.completed) / 100,
        milestone: item.isMilestone,
        // pointWidth: item[8 /*isStage*/] ? 3 : byResources && item[12 /*isInCollision*/] ? 60 : undefined, //?neni v GanttPointOptionsObject
        borderColor: item.isInCollision ? "red" : null,
        borderWidth: item.isInCollision ? 3 : null,
        // serieName: item[3],
        dependency: itemdependencies,
        custom: {
          workTime: item.workTime,
          workTimeUnit: item.workTimeUnit,
          htmlTooltip: item.htmlTooltip,
        },
      };

      if (ownColors && item.customColor) {
        (data as any).color = item.customColor;
      } else {
        (data as any).color = defaultColors[itemindex % defaultColors.length];
      }

      if (byResources) {
        return {
          y: item.resourceOrder,
          ...data,
        };
      } else {
        return {
          y: byResources ? item.resourceOrder : itemindex,
          parent: item.parentId == 0 ? null : item.parentId.toString(),
          ...data,
        };
      }
    }
  );

  return dataitems;
};

export const getSeries = (operations: GanttOperation[], dataitems: GanttPointOptionsObject[]) => {
  let seriesdataitemsarray: string[] = [];
  let found: boolean;
  let serieName: string;
  for (let i = 0; i < operations.length; i++) {
    serieName = operations[i].serieName;
    found = false;
    for (let j = 0; j < seriesdataitemsarray.length; j++) {
      if (seriesdataitemsarray[j] == serieName) {
        found = true;
      }
    }
    if (!found) {
      seriesdataitemsarray.push(serieName);
    }
  }

  //2. dataitems do serii
  let seriesdataitems: Highcharts.SeriesGanttOptions[] = [];
  for (let i = 0; i < seriesdataitemsarray.length; i++) {
    serieName = seriesdataitemsarray[i];

    let dataitemsforserie = new Array<Highcharts.GanttPointOptionsObject>();

    for (let j = 0; j < operations.length; j++) {
      if (serieName == operations[j].serieName) {
        dataitemsforserie.push(dataitems[j]);
      }
    }

    seriesdataitems.push({
      name: serieName,
      type: "gantt",
      data: dataitemsforserie,
    });
  }

  return seriesdataitems;
};

export const getArrayOfCategories = (resources: GanttResource[]) => {
  if (resources == undefined) return [];

  let arrayOfCategories = resources.map((item) => item.abbr);

  return arrayOfCategories;
};

export const getYAxisOptions = (
  byOperations: boolean,
  byResources: boolean,
  arrayOfCategories: string[],
  resources: GanttResource[],
  operations: GanttOperation[],
  isDesktop: boolean,
  fontColor: string
) => {
  let yAxisOptions: Highcharts.YAxisOptions;

  if (byOperations) {
    let categories = operations.map((item) => item.name);

    yAxisOptions = {
      type: "treegrid",
      staticScale: isDesktop ? 22 : 21,
      // categories: categories,
      labels: {
        enabled: true,
        style: {
          color: fontColor,
        },
      },
      breaks: categories.map(() => {
        return {
          breakSize: 0,
          from: 0,
          to: 0,
        };
      }),
      //     labels: {
      //       enabled: true,
      //     },
      //     grid: {
      //       columns: [
      //         {
      //           title: {
      //             //text: "Etapy/činnosti",
      //           },
      //           labels: {
      //             format: "{point.name}",
      //           },
      //         },
      //       ],
      //     },
    };
  }

  //GRAF ZDROJU
  if (byResources) {
    yAxisOptions = {
      type: "category",
      staticScale: isDesktop ? 22 : 21,
      labels: {
        enabled: true,
        style: {
          color: fontColor,
        },
        formatter: (context) => {
          const value = context.value as string;

          for (const resource of resources) {
            const currentRow = resource.abbr === value;

            if (currentRow) {
              // if (value === "LOSKOT") {
              //   resource.hasCollision = true;
              // }

              if (resource.hasCollision) {
                return `<span style="color: red">${value}</span>`;
              }
            }
          }

          return value;
        },
      },
      categories: arrayOfCategories,
      min: 0,
      max: arrayOfCategories.length - 1,
      showEmpty: true,
      startOfWeek: 1,
      // grid: {
      // columns: [
      //   {
      //     title: {
      //       //text: "Zdroje",
      //     },
      //   },
      // ],
      // },
    };
  }

  return yAxisOptions;
};

export const updateDataAfterDrop = (e: Highcharts.PointDropEventObject) => {
  let updatedData: string[][] = [];
  let newPoints: Highcharts.Dictionary<Highcharts.PointDragDropObject> = e.newPoints;

  for (let id in newPoints) {
    let changes: Highcharts.PointDragDropObject = newPoints[id];

    for (let key in changes.newValues) {
      let value = changes.newValues[key];

      if (key === "end") {
        value = new Date(value).setSeconds(new Date(value).getSeconds() - 2);
      }

      updatedData.push([id, key, value.toString()]);
    }
  }

  return updatedData;
};

export const NoData = (colors: ColorProps) => {
  if (!colors) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
        background: colors.DataBrowseColorBck,
      }}
    >
      <div
        style={{
          display: "flex",
          flex: "1 1 auto",
          background: colors.ContentFrame1,
          color: colors.DataBrowseColorFrg,
          padding: "3px",
          justifyContent: "center",
        }}
      >
        Žádná data k zobrazení
      </div>
    </div>
  );
};

const defaultColors = ["#7cb5ec", "#434348", "#90ed7d", "#f7a35c", "#8085e9", "#f15c80", "#e4d354", "#2b908f", "#f45b5b", "#91e8e1"];
